/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const de_login_callback__close_button = /** @type {(inputs: {}) => string} */ () => {
	return `Schließen`
};

const en_login_callback__close_button = /** @type {(inputs: {}) => string} */ () => {
	return `Close`
};

const es_login_callback__close_button = /** @type {(inputs: {}) => string} */ () => {
	return `Cerrar`
};

const fr_login_callback__close_button = /** @type {(inputs: {}) => string} */ () => {
	return `Fermer`
};

const it_login_callback__close_button = /** @type {(inputs: {}) => string} */ () => {
	return `Chiudi`
};

const nl_login_callback__close_button = /** @type {(inputs: {}) => string} */ () => {
	return `Sluiten`
};

const pt_login_callback__close_button = /** @type {(inputs: {}) => string} */ () => {
	return `Fechar`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "de" | "en" | "es" | "fr" | "it" | "nl" | "pt" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const login_callback__close_button = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.login_callback__close_button(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("login_callback__close_button", locale)
	if (locale === "de") return de_login_callback__close_button(inputs)
	if (locale === "en") return en_login_callback__close_button(inputs)
	if (locale === "es") return es_login_callback__close_button(inputs)
	if (locale === "fr") return fr_login_callback__close_button(inputs)
	if (locale === "it") return it_login_callback__close_button(inputs)
	if (locale === "nl") return nl_login_callback__close_button(inputs)
	return pt_login_callback__close_button(inputs)
};